import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import styled from 'styled-components';
export var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  padding: 16px;\n"])), function (_ref) {
  var _theme$colors;
  var theme = _ref.theme;
  return ((_theme$colors = theme.colors) == null ? void 0 : _theme$colors.background) || '#fff';
});
export var Link = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"])), function (_ref2) {
  var _theme$colors2;
  var theme = _ref2.theme;
  return ((_theme$colors2 = theme.colors) == null ? void 0 : _theme$colors2.textSecondary) || '#666';
});
export var List = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  line-height: 1.6;\n  margin: 0;\n"])));
export var Separator = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref3) {
  var _theme$colors3;
  var theme = _ref3.theme;
  return ((_theme$colors3 = theme.colors) == null ? void 0 : _theme$colors3.textSecondary) || '#666';
});
export var Title = styled.h2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  margin-top: 0;\n"])), function (_ref4) {
  var _theme$colors4;
  var theme = _ref4.theme;
  return ((_theme$colors4 = theme.colors) == null ? void 0 : _theme$colors4.textSecondary) || '#666';
});